import React, { forwardRef } from 'react'
import Button from './Button'
import { noop } from 'lodash-es'

type DotMenuProps = {
  className?: string
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  ariaLabel?: string
  title?: string
}

const DotMenu = forwardRef<HTMLButtonElement, DotMenuProps>((props, ref) => {
  const { className = 'dot-menu-icon min-mobile-hit-area', onClick = noop, ariaLabel = '', title = 'Actions' } = props

  return (
    <Button
      className={`${className} dot-menu-icon min-mobile-hit-area`}
      aria-label={ariaLabel}
      onClick={onClick}
      ref={ref}
      title={title}
    >
      <span className="hit-area-wrapper">
        <div className="hit-area-container">
          <div className="hit-area"></div>
        </div>
      </span>
      <span className="dot-menu-icon__dot"></span>
      <span className="dot-menu-icon__dot"></span>
      <span className="dot-menu-icon__dot"></span>
    </Button>
  )
})

DotMenu.displayName = 'DotMenu'

export default DotMenu
